export default __webpack_public_path__ + "static/media/export.9f17c5af.svg";